var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10751(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10752",
    "data-name": "Group 10752",
    transform: "translate(-2841.104 -102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 10,
    height: 14,
    rx: 2,
    transform: "translate(2841.104 102)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 10,
    height: 14,
    rx: 2,
    transform: "translate(2846.104 102)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10751);
export default __webpack_public_path__ + "static/media/Group 10751.4d4927e51ec95f8f0de6ed7893860324.svg";
export { ForwardRef as ReactComponent };